import React from 'react';
import { graphql } from 'gatsby';

// This block is not being used and will be removed.

const ContactBanner: React.FC<Queries.ContactBannerDataFragment> = () => null;

export const query = graphql`
  fragment ContactBannerData on CsContactBanner {
    ... on CsContactBanner {
      content {
        headline
        subline
        copy
        image {
          filename
          title
          url
          description
          contentStackAsset(width: 1440)
        }
      }
    }
  }
`;

export default ContactBanner;
